'use client';

import { useScrollTrigger } from '../../lib/useScrollTrigger.js';
import { cn } from '../../lib/utils.js';

/**
 * ScrollAnimation wrapper component
 */
export function ScrollAnimation({
  children,
  animation = 'fadeUp',
  duration = 0.8,
  delay = 0,
  start = 'top 85%',
  className,
  as: Component = 'div',
  ...props
}) {
  const animations = {
    fadeUp: {
      from: { opacity: 0, y: 50 },
      animation: { opacity: 1, y: 0, duration, delay },
    },
    fadeDown: {
      from: { opacity: 0, y: -50 },
      animation: { opacity: 1, y: 0, duration, delay },
    },
    fadeLeft: {
      from: { opacity: 0, x: -50 },
      animation: { opacity: 1, x: 0, duration, delay },
    },
    fadeRight: {
      from: { opacity: 0, x: 50 },
      animation: { opacity: 1, x: 0, duration, delay },
    },
    scaleIn: {
      from: { opacity: 0, scale: 0.9 },
      animation: { opacity: 1, scale: 1, duration, delay },
    },
    clipLeft: {
      from: { clipPath: 'inset(0 100% 0 0)' },
      animation: { clipPath: 'inset(0 0% 0 0)', duration, delay },
    },
    clipRight: {
      from: { clipPath: 'inset(0 0 0 100%)' },
      animation: { clipPath: 'inset(0 0 0 0%)', duration, delay },
    },
  };

  const config = animations[animation] || animations.fadeUp;

  const ref = useScrollTrigger({
    from: config.from,
    animation: config.animation,
    start,
  });

  return (
    <Component ref={ref} className={cn('gsap-hidden', className)} {...props}>
      {children}
    </Component>
  );
}

export default ScrollAnimation;
